<div>
  <p-tabView [activeIndex]="index" (onChange)="handleChange($event)">
    <p-tabPanel *ngFor="let item of tabs" header="{{item.label}}">
    </p-tabPanel>
  </p-tabView>
</div>
